module.exports = __webpack_public_path__ + "static/jll_logo-4d186fbcf7ff13de36ff81ed73f817c2.png";